import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../api.service'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

@Component({
  selector: 'app-item-add',
  templateUrl: './item-add.component.html',
  styleUrls: ['./item-add.component.scss']
})
export class ItemAddComponent implements OnInit {

  @ViewChild('thumbnailUploader') thumbnailUploader: ElementRef;
  @ViewChild('postImageUploader') postImageUploader: ElementRef;

  isUserLogin: boolean
  addForm: FormGroup
  itemId: string
  itemType: string
  itemUrl: string
  itemTitle: string
  thumbnailImage: string
  postImages: object
  postImagesField: string
  postLocation: string[] | null = null;
  lat: number | null = null;
  lng: number | null = null;
  allUrls: any
  uniquePathCheck: boolean
  id: any
  uploadFile: File = null
  uploadFileName: string
  postImageType: string
  isThumbnail: string
  public errorMsg: any

  // google maps zoom level
  zoom: number = 12;
  center?: google.maps.LatLngLiteral;
  circleOptions: google.maps.CircleOptions = {
    radius: 5000,
    fillColor: 'red',
    draggable: true,
    editable: true
  };
  mapOptions: google.maps.MapOptions;
  markers: MapMarkerData[] = [];
  selectedMarkerLabel?: string;

  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;

  constructor(private fb: FormBuilder,
    private userApi : ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location ) { 
      const newLocal = this.isUserLogin = this.userApi.isLoggedIn();
    }

  ngOnInit(): void {
    this.mapOptions = {
      disableDefaultUI: false,
      zoomControl: false,
      streetViewControl: false,
      styles: this.styles
    };
    
    this.itemType = this.route.snapshot.paramMap.get("type")
    // console.log(this.route.snapshot.paramMap)

    if(this.itemType === 'photography') {
      this.addForm = this.fb.group({
        id: [''],
        title: ['', Validators.required],
        meta_keywords: [''],
        meta_description: [''],
        post_description: [''],
        url: ['', [Validators.required]],
        thumbnail_image: ['', [Validators.required]],
        post_category: ['', [Validators.required]],
        post_images: ['', [Validators.required]],
        post_type: ['', [Validators.required]],
        post_location: ['']
      });
  
      this.userApi.getPhotos('all',null).subscribe(
        data => {
          for(let item of data) {
            if(this.allUrls != undefined) {
              this.allUrls =  this.allUrls + ';' + item.url;
            }else {
              this.allUrls = item.url
            }         
          }
          this.allUrls = this.allUrls.split(';');
        },
        error => this.errorMsg = error      
      );
    } else {
      this.addForm = this.fb.group({
        id: [''],
        title: ['', Validators.required],
        meta_keywords: [''],
        meta_description: [''],
        post_description: [''],
        site_link: [''],
        url: ['', [Validators.required]],
        thumbnail_image: ['', [Validators.required]],
        post_category: ['', [Validators.required]],
        post_images: ['', [Validators.required]],
        designer: [''],
        designer_url: [''],
        ecommerce_website: [''],
        post_type: ['', [Validators.required]]
      });
  
      this.userApi.getWebsites('all',null).subscribe(
        data => {
          for(let item of data) {
            if(this.allUrls != undefined) {
              this.allUrls =  this.allUrls + ';' + item.url;
            }else {
              this.allUrls = item.url
            }         
          }
          this.allUrls = this.allUrls.split(';');
        },
        error => this.errorMsg = error      
      );
    }
    
  }

  onPostImagesField(event: any){
    this.postImagesField = event.target.value
    this.postImages = this.postImagesField.split(',')
    this.addForm.value.post_images = this.postImagesField
  }

  onThumbnailImageField(event: any){
    this.thumbnailImage = event.target.value
    this.addForm.value.thumbnail_image = this.thumbnailImage
  }

  onLocationChange(event: any){
    // console.log(event)
    const newLocation = event.target.value
    this.postLocation = newLocation ? newLocation.split(',') : null;
    console.log(this.postLocation)
    if (Array.isArray(this.postLocation) && this.postLocation.length === 2) {
      const parsedLat = parseFloat(this.postLocation[0]);
      const parsedLng = parseFloat(this.postLocation[1]);
      if (!isNaN(parsedLat) && !isNaN(parsedLng)) {
        this.lat = parsedLat;
        this.lng = parsedLng;
        this.updateMarkers(parsedLat, parsedLng, this.itemTitle);
      }
    } else {
      this.lat = null;
      this.lng = null;
      this.center = undefined;
      this.markers = [];
    }
  }

  onFileSelected(event: any){
    this.postImageType = event.target.name
    this.isThumbnail = event.target.attributes['thumbnail'].value
    this.uploadFile =  <File>event.target.files[0]
    this.uploadFileName = event.target.files[0].name
  }

  onFileUpload(){    
    const formData = new FormData()
    formData.append('image', this.uploadFile)
    this.userApi.uploadImage(formData, this.postImageType, this.isThumbnail)
    .subscribe((data:any) => {
      // console.log(data);
      if(this.isThumbnail === "true"){
        this.thumbnailImage = this.uploadFileName
        this.thumbnailUploader.nativeElement.value = null
        this.addForm.value.thumbnail_image = this.thumbnailImage
      } else {
        if(this.postImagesField != '') {
          this.postImagesField = this.postImagesField + ',' + this.uploadFileName
          this.postImages = this.postImagesField.split(',')
          this.postImageUploader.nativeElement.value = null
          this.addForm.value.post_images = this.postImagesField
        } else {
          this.postImagesField = this.uploadFileName
          this.postImages = this.postImagesField.split(',')
          this.postImageUploader.nativeElement.value = null
          this.addForm.value.post_images = this.postImagesField
        }
      }
    });
  }

  onSave(){
    let formValue = this.addForm.value
    // console.log(formValue)
    // console.log(this.allUrls);
    // this.uniquePathCheck = this.allUrls.find(u => u !== formValue.url);
    for(let url of this.allUrls){
      
      if(formValue.url === url) {
        // console.log(url);
        this.uniquePathCheck = true
        break
      } else {
        this.uniquePathCheck = false
      }
    }
    // console.log(this.uniquePathCheck)
    // console.log(this.uniquePathCheck)
    if(!this.uniquePathCheck) {
      this.userApi.addItem(formValue)
      .subscribe(() => {
        this.itemType === 'photography' ? this.router.navigate(['/user/dashboard/photography']) : this.router.navigate(['/user/dashboard/web']);
      })
    }  
  }

  goBack() {
    this.location.back();
  }

  updateMarkers(lat: number, lng: number, label?: string) {
    this.center = { lat, lng };
    this.markers = [
	    {
		    position: { lat, lng },
		    label: label || this.itemTitle || 'Location',
		    draggable: false
	    }
    ];
  }

  clickedMarker(label: string | undefined, index: number, marker: MapMarker) {
    this.selectedMarkerLabel = label || index.toString();
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
    console.log(`clicked the marker: ${label || index}`);
  }
  
  mapClicked(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      const position = event.latLng.toJSON();
      this.markers.push({
        position,
        label: `Marker ${this.markers.length + 1}`,
        draggable: false
      });
    }
  }
  
  markerDragEnd(marker: MapMarkerData, event: google.maps.MapMouseEvent) {
    console.log('dragEnd', marker, event);
  }

  styles: any[] =
    [
      {
        "featureType":"landscape.natural",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#dfdfdf"
            }
        ]
      },
      {
        "featureType":"landscape.man_made",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#d7d9d9"
            }
        ]
      },
      {
        "featureType":"road.highway",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#afafaf"
            }
        ]
      },
      {
        "featureType":"road.arterial",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#dedede"
            }
        ]
      },
      {
        "featureType":"road",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#ababab"
            }
        ]
      },
      {
        "featureType":"poi",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#e6e6e6"
            }
        ]
      },
      {
        "featureType":"road.local",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#010404"
            }
        ]
      },
      {
        "featureType":"road.arterial",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#040404"
            }
        ]
      },
      {
        "featureType":"road.highway",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#0f0f01"
            }
        ]
      }
  ]

}

// just an interface for type safety.
interface MapMarkerData {
	position: google.maps.LatLngLiteral;
	label?: string;
	draggable: boolean;
}
